module.exports = __webpack_public_path__ + "static/media/05_pre-enrollment-enjoy-plan.5404de50.svg";